const STORAGE_KEY = 'visit_drafts_v1';

function safeParse(value, fallback) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return fallback;
  }
}

function readDrafts() {
  const drafts = safeParse(window.localStorage.getItem(STORAGE_KEY), []);
  return Array.isArray(drafts) ? drafts : [];
}

function writeDrafts(drafts) {
  window.localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(Array.isArray(drafts) ? drafts : []),
  );
}

function normalizeId(value) {
  return value ? String(value) : '';
}

export function createVisitDraftId() {
  return `visit_draft_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function listVisitDrafts({userId, mode, isCoVisit} = {}) {
  return readDrafts()
    .filter((draft) => {
      if (userId && normalizeId(draft.userId) !== normalizeId(userId)) {
        return false;
      }
      if (mode && draft.mode !== mode) {
        return false;
      }
      if (typeof isCoVisit === 'boolean' && Boolean(draft.isCoVisit) !== isCoVisit) {
        return false;
      }
      return true;
    })
    .sort((a, b) => new Date(b.updatedAt || 0).getTime() - new Date(a.updatedAt || 0).getTime());
}

export function getVisitDraft(draftId) {
  if (!draftId) {
    return null;
  }
  return readDrafts().find((draft) => draft.draftId === draftId) || null;
}

export function findVisitDraftBySource({userId, mode, sourceCallId}) {
  if (!sourceCallId) {
    return null;
  }

  return listVisitDrafts({userId, mode}).find(
    (draft) => normalizeId(draft.sourceCallId) === normalizeId(sourceCallId),
  ) || null;
}

export function upsertVisitDraft(draft) {
  const drafts = readDrafts();
  const now = new Date().toISOString();
  const normalizedDraft = {
    ...draft,
    draftId: draft.draftId || createVisitDraftId(),
    sourceCallId: normalizeId(draft.sourceCallId),
    updatedAt: now,
    createdAt: draft.createdAt || now,
  };
  const index = drafts.findIndex((item) => item.draftId === normalizedDraft.draftId);

  if (index > -1) {
    drafts.splice(index, 1, normalizedDraft);
  } else {
    drafts.push(normalizedDraft);
  }

  writeDrafts(drafts);
  return normalizedDraft;
}

export function removeVisitDraft(draftId) {
  if (!draftId) {
    return;
  }
  writeDrafts(readDrafts().filter((draft) => draft.draftId !== draftId));
}

export function removeVisitDraftBySource({userId, mode, sourceCallId}) {
  if (!sourceCallId) {
    return;
  }

  writeDrafts(
    readDrafts().filter((draft) => {
      if (normalizeId(draft.sourceCallId) !== normalizeId(sourceCallId)) {
        return true;
      }
      if (userId && normalizeId(draft.userId) !== normalizeId(userId)) {
        return true;
      }
      if (mode && draft.mode !== mode) {
        return true;
      }
      return false;
    }),
  );
}

export function buildVisitDraftListItem(draft) {
  const formState = draft.formState || {};
  const physician = draft.physician || {};
  const feedbackState = draft.feedbackState || {};
  const insightFormList = feedbackState.insightFormList || [];
  const hasPendingFeedbackInput = Boolean(
    (feedbackState.inputText && String(feedbackState.inputText).trim()) ||
    feedbackState.pendingVoiceData ||
    feedbackState.currentQuestion ||
    feedbackState.tempTranslateResult,
  );
  const totalFeedbackCount = insightFormList.length + (hasPendingFeedbackInput ? 1 : 0);
  const companions = (formState.companions || []).map((item) => ({
    user_id: item.user_id,
    user_name: item.user_name,
  }));

  return {
    draft_id: draft.draftId,
    physician_mr_call_id: draft.sourceCallId || '',
    is_co_call: draft.isCoVisit ? 1 : 0,
    is_draft: true,
    draft_updated_at: draft.updatedAt,
    crm_status: 'draft',
    is_diner: Boolean(draft.showAddExpense),
    feedback_count: totalFeedbackCount,
    has_feedback: totalFeedbackCount > 0,
    has_pending_feedback_input: hasPendingFeedbackInput,
    call_time: formState.call_time || draft.updatedAt,
    physician: {
      physician_id: formState.physician_id || physician.physician_id || '',
      physician_name: physician.physician_name || '',
      department_name: physician.department_name || '',
      professional_title: physician.professional_title || '',
      institution_name: physician.institution_name || '',
    },
    physician_mr_call__physician_mr_call_companions: companions,
  };
}
